export function occurrenceDescriptionCore() {
  const endpoint = '/vistaorder/statuses';

  return {
      endpoint,
  };
}

export function occurrenceDescriptionFilter() {
  const parameter = 'OccurrenceCode';

  // Get rows
  const getRows = (data) => {
    const rows = [];

    data.forEach((row, i) => {
      // Text/numeric values
      rows[i] = {
        value: row.filterValue,
        label: row.filterText,
      };
    });

    return rows;
  };

  return {
    parameter,
    getRows: getRows
  };
}
